export const paginationHeightRem = 5.6;
export const navbarHeightRem = 8;
export const verticalPageContentPaddingHeightRem = 4.8;
